import type { Credential, SocialLink } from './schema'

/** Identity and contact facts used across the site. */
export const site = {
  name: 'Kenneth Villar',
  brand: 'BrewedOps',
  /** Brand kit mark, made transparent by scripts/make-logo.py. One file per theme. WebP copies from
   *  scripts/make-image-variants.py: 128px for the logo faces, 96px for the header (shown at 32-36px). */
  logo: {
    light: '/images/brand/brewedops-mark.webp',
    dark: '/images/brand/brewedops-mark-light.webp',
    headerLight: '/images/brand/brewedops-mark-96.webp',
    headerDark: '/images/brand/brewedops-mark-light-96.webp',
  },
  url: 'https://portfoliov2.brewedops.cloud',
  role: 'Certified GHL Admin',
  memberId: '#7009',
  email: 'brewedops@gmail.com',
  emailSubject: 'Automation plan request',
  replyPromise: 'Reply within one business day.',
  location: 'Philippines, GMT+8',
  /** Kenneth's clock, shown live at the top of the sidebar. */
  timeZone: 'Asia/Manila',
  timePlace: 'in the Philippines',
  avatar: { src: '/images/profile/avatar.webp', alt: 'Kenneth Villar', width: 400, height: 400 },
  /** The sidebar picture (112px, 44px on the rail). */
  avatarSmall: '/images/profile/avatar-224.webp',
} as const

export const certification: Credential = {
  title: 'HighLevel Certified Admin',
  detail: 'Member ID #7009',
  href: 'https://directory.gohighlevel.com/profile/7009-kenneth-villar',
  image: { src: '/images/badges/ghl-certified.webp', alt: 'HighLevel Certified Admin badge', width: 96, height: 96 },
}

export const socials: SocialLink[] = [
  { label: 'Facebook', href: 'https://www.facebook.com/BrewedOpsHL', external: true, icon: 'facebook' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/kenneth-villar-10a05734a/', external: true, icon: 'linkedin' },
  { label: 'Discord', href: 'https://discord.com/users/kapedlvnglgnd', external: true, icon: 'discord' },
  { label: 'HL Accelerator', href: 'https://hlaccelerator.com', external: true, icon: 'hl-accelerator' },
  // Ray Ingotan's Diskarte Digital (Kenneth's partner): its Facebook page (Kenneth, 2026-10-03).
  { label: 'Diskarte Digital', href: 'https://www.facebook.com/profile.php?id=61593732969412', external: true, icon: 'diskarte', partner: true },
]

export const externalLinks = {
  framework: 'https://brewedops.cloud/framework/',
  workflow: 'https://brewedops.cloud/workflow/',
  ticketing: 'https://brewedops.cloud/ticketingsystem/',
  kapeTools: 'https://kape.tools',
  brewedops: 'https://brewedops.com',
} as const

export function mailtoHref(): string {
  return `mailto:${site.email}?subject=${encodeURIComponent(site.emailSubject)}`
}
